/**
 * Английский словарь: русская строка → перевод.
 *
 * Ключи — дословные русские строки из кода (см. lib/i18n.ts, почему так).
 * Пропущенный ключ покажется по-русски: заметно, но ничего не ломает.
 * Сюда же входят серверные сообщения об ошибках — они переводятся
 * на клиенте в момент показа (lib/api.ts).
 */
export const en: Record<string, string> = {
  'Просрочка аренды': 'Overdue rent',
  'Итого': 'Total',
  'На проверку': 'Needs review',
  'список недоступен': 'list unavailable',
  'не входят в итог: Rent не уверен в расчёте': 'not in the total: Rent is not sure about the calculation',
  'Причины': 'Reasons',
  'Было бы к оплате': 'Would be overdue',
  'по квитанциям': 'by receipts',
  'по проводкам': 'by ledger',
  'Просрочка аренды: данные временно недоступны.': 'Overdue rent: data temporarily unavailable.',
  'Источник не настроен': 'Source not configured',
  'Расчёт недоступен': 'Calculation unavailable',
  'Это не значит, что просрочек нет.': 'This does not mean nothing is overdue.',
  'Данные неполные': 'Incomplete data',
  'Просроченной аренды нет.': 'No overdue rent.',
  'Строк просрочки нет в полученных данных.': 'No overdue rows in the received data.',
  'Срок оплаты': 'Due date',
  'Дней': 'Days',
  'оплачено частично': 'partly paid',
  'после выезда': 'after checkout',
  'Источник: Rent, расчёт на': 'Source: Rent, calculated for',
  'льготный период': 'grace period',
  'дн.': 'd.',
  'Объект не указан': 'Unit not set',
  'Текущая работа': 'Current work',
  "Подтверждено": "Confirmed",
  "Гость заехал": "Checked in",
  "Гость выехал": "Checked out",
  "Ожидание депозита": "Awaiting deposit",
  "Предварительная бронь": "On hold",
  "Запланировано": "Scheduled",
  "Не оплачен": "Unpaid",
  "К оплате сегодня": "Due today",
  "Оплачен": "Paid",
  "Оплачен частично": "Partially paid",
  "Просрочен": "Overdue",
  "Ожидает": "Pending",
  "Календарь аренды за период недоступен. Требуется обновление источника.": "Rental calendar for this period is unavailable. The source needs updating.",
  "События на {date}": "Events on {date}",
  "+ событие": "+ event",
  "На этот день ничего не запланировано.": "Nothing scheduled for this day.",
  "{date}: событий {count}": "{date}: {count} events",
  "Данные аренды загружаются…": "Loading rental events\u2026",
  "Данные аренды недоступны. Повторите загрузку.": "Rental events unavailable. Try again.",
  "Данные аренды за весь период недоступны. Доступно только сегодня.": "Rental events for this period are unavailable. Only today is available.",
  "Нет видимых событий. Проверьте фильтры.": "No visible events. Check the filters.",
  "Показать всё": "Show all",
  "Аренда: {count} событий · обновлено {time}": "Rentals: {count} events \u00b7 updated {time}",
  "Повторить загрузку": "Retry",
  "Не указано": "Not provided",
  "Требуется сверка": "Review required",
  "Открыть карточку": "Open the card",
  "confirmed": "Confirmed",
  "pending": "Pending",
  "paid": "Paid",
  "overdue": "Overdue",
  'Ответственный': 'Responsible',
  'Подробнее': 'Details',
  'Скопируйте идентификатор вручную: {id}': 'Copy this identifier manually: {id}',
  'Аренда · заявки': 'Rentals · leads',
  'Трансферы доступны для просмотра. Изменения — в Oleg.': 'Transfers are read-only here. Make changes in Oleg.',
  'Заезды, выезды и платежи показаны только на сегодня.': 'Check-ins, check-outs and payments are shown for today only.',

  'Неразобранные задачи': 'Unsorted tasks',
  'Неразобранных задач нет': 'No unsorted tasks',
  'Разобрать задачи': 'Organize tasks',
  'Разобрать задачу': 'Organize task',
  // ── Общее / кнопки ──
  'Дом': 'Home',
  'Семейный хаб': 'Family hub',
  'Личный командный центр': 'Personal command center',
  'Сохранить': 'Save',
  'Сохраняю': 'Saving',
  'Сохраняю…': 'Saving…',
  'Сохранено': 'Saved',
  'Не сохранено': 'Not saved',
  'Отмена': 'Cancel',
  'Удалить': 'Delete',
  'Создать': 'Create',
  'Создаю': 'Creating',
  'Добавить': 'Add',
  'Изменить': 'Edit',
  'Закрыть': 'Close',
  'Копировать': 'Copy',
  'Скопировано': 'Copied',
  'Подтвердить': 'Confirm',
  'Вернуть': 'Restore',
  'Убрать': 'Remove',
  'Сбросить': 'Reset',
  'Отозвать': 'Revoke',
  'Развернуть': 'Expand',
  'Свернуть': 'Collapse',
  'Назад': 'Back',
  'Вперёд': 'Forward',
  'Ещё': 'More',
  'Ещё раз': 'Try again',
  'ещё': 'more',
  'из': 'of',
  'или': 'or',
  'Все': 'All',
  'Пусто': 'Empty',
  'Пока пусто.': 'Nothing here yet.',
  'Загружаю…': 'Loading…',
  'Проверяю': 'Checking',
  'Не получилось': 'Something went wrong',
  'Название': 'Name',
  'Имя': 'Name',
  'Описание': 'Description',
  'Цвет': 'Colour',
  'Цвет {color}': 'Colour {color}',
  'Дата': 'Date',
  'Сегодня': 'Today',
  'Скоро': 'Soon',
  'Б': 'B',
  'КБ': 'KB',
  'МБ': 'MB',
  '← Список': '← List',
  ' — ещё нет': ' — none yet',

  // ── Навигация и разделы ──
  'Задачи': 'Tasks',
  'Календарь': 'Calendar',
  'Заметки': 'Notes',
  'Деньги': 'Money',
  'План и прогноз': 'Plan and forecast',
  'Сообщение гостя': 'Guest message',
  'Входящие': 'Inbox',
  'Настройки': 'Settings',
  'Пользователи': 'People',
  'Поиск': 'Search',
  'Выйти': 'Sign out',
  'Что и когда': 'What and when',
  'Что нужно сделать': 'Things to do',
  'Что нужно помнить': 'Things to remember',
  'Счета и траты': 'Accounts and spending',
  'Кто живёт в доме': 'Who lives here',
  'Проекты и дела': 'Projects and tasks',
  'Решения': 'Decisions',
  'Жду': 'Waiting',
  'Быстрый ввод': 'Quick capture',
  'Сохранить как': 'Save as',
  'Сначала выберите, куда сохранить мысль.': 'Choose where to save the thought first.',
  'Ожидание': 'Waiting item',
  'Нужно сделать': 'Something to do',
  'Жду ответ или действие': 'Waiting for an answer or action',
  'Фиксирую правило': 'Recording a decision',
  'Сохраняю контекст': 'Saving context',
  'Название заметки': 'Note title',
  'Добавить ожидание': 'Add waiting item',
  'Добавить решение': 'Add decision',
  'Создать заметку': 'Create note',
  'Сначала сформулируйте мысль.': 'Write the thought first.',
  'Укажите, от кого ждёте ответ.': 'Say who you are waiting for.',
  'Записать': 'Capture',
  'История управленческих решений': 'A record of management decisions',
  'Новые решения': 'New decision',
  'Новое решение': 'New decision',
  'Изменить решение': 'Edit decision',
  'Активные': 'Active',
  'Решение': 'Decision',
  'Что решили': 'What was decided?',
  'Почему': 'Why',
  'На что влияет': 'Impact',
  'Причина решения': 'Why does this make sense?',
  'Какие проекты или процессы затрагивает': 'Which projects or processes does it affect?',
  'Активно': 'Active',
  'Устарело': 'Superseded',
  'Пометить устаревшим': 'Mark as superseded',
  'Вернуть в активные': 'Make active again',
  'Решений пока нет.': 'No decisions here yet.',
  'Решений пока нет. Нажмите «Новое решение», чтобы записать, что решили и почему.': 'No decisions yet. Press “New decision” to write down what you decided and why.',
  'Решение должно быть сформулировано.': 'Write down the decision.',
  'Не удалось загрузить решения': 'Could not load decisions',
  'История ожиданий': 'Open loops and follow-ups',
  'Новое ожидание': 'New waiting item',
  'Изменить ожидание': 'Edit waiting item',
  'Открытые': 'Open',
  'Закрытые': 'Closed',
  'Что ждём': 'What are we waiting for?',
  'От кого ждём': 'Waiting for',
  'Контекст': 'Context',
  'Следующее напоминание': 'Follow-up date',
  'Открыто': 'Open',
  'Получено': 'Received',
  'Пометить полученным': 'Mark as received',
  'Вернуть в ожидание': 'Reopen waiting item',
  'Ожиданий пока нет.': 'No waiting items here yet.',
  'Ожиданий пока нет. Нажмите «Новое ожидание», чтобы не забыть, кого ждёте.': 'Nothing is waiting. Press “New follow-up” so you do not forget who you are waiting on.',
  'Ожидание должно быть сформулировано.': 'Write down what is pending.',
  'Например: документы по объекту': 'For example: property documents',
  'Имя человека или компании': 'A person or company',
  'Что важно помнить при следующем контакте': 'What should be remembered at the next follow-up?',
  'Не удалось загрузить ожидания': 'Could not load waiting items',
  'Быстрый вход для несортированных мыслей': 'Quick capture for unsorted thoughts',
  'Сюда попадают быстрые мысли. Разберите их по проектам, когда появится время.':
    'Capture thoughts here and sort them into projects later.',
  'Открыть проекты': 'Open projects',
  'Новая мысль': 'New thought',
  'Требует внимания': 'Requires attention',
  'Есть мысли, которые нужно разобрать': 'Thoughts are waiting to be sorted',
  'Перейдите, чтобы разложить их по проектам.': 'Open Inbox and sort them into projects.',
  'Входящие чисты': 'Inbox is clear',
  'Быстрый ввод готов для следующей мысли.': 'Quick capture is ready for the next thought.',
  'Разобрать входящие': 'Triage Inbox',
  'Разобрать сегодня': 'Review today',
  'Разобрать во Входящих': 'Triage in Inbox',
  'Напомнить {name}': 'Follow up with {name}',
  'Добавить причину и влияние': 'Add rationale and impact',
  'Утренний обзор': 'Morning brief',
  'Требуют внимания: {count}': 'Needs attention: {count}',
  'Ваши действия: {count}': 'Your actions: {count}',
  'Сначала выполните личные действия, затем разберите очередь.':
    'Start with your actions, then work through the review queue.',
  'Мои действия': 'My actions',
  'На вас назначенных действий на сегодня нет.': 'No actions are assigned to you for today.',
  'Открыть мои задачи': 'Open my tasks',
  'сегодня или просрочено': 'due today or overdue',
  'Нужно пинговать: {count}': 'Follow-ups due: {count}',
  'Просрочено: {count}': 'Overdue: {count}',
  'Сегодня: {count}': 'Due today: {count}',
  'Критических сигналов Oleg: {count}': 'Critical Oleg signals: {count}',
  'Сегодня можно работать без срочных хвостов.': 'No urgent loose ends today.',
  'Фокус': 'Focus',
  'приоритетных пунктов': 'priority items',
  'к разбору': 'to sort',
  'следующих действий': 'follow-ups due',
  'событий сегодня': 'events today',
  'активных': 'active',
  'операционных сигналов': 'operational signals',
  'Открытых ожиданий нет.': 'No open waiting items.',
  'Открыть ожидания': 'Open waiting list',
  'Активных решений нет.': 'No active decisions.',
  'Открыть решения': 'Open decisions',
  'Проекты': 'Projects',
  'Активных проектов пока нет. Создайте первый в разделе задач.':
    'No active projects yet. Create the first one in Tasks.',
  'Следующий шаг': 'Next step',
  'Все задачи закрыты': 'All tasks are complete',
  'Oleg': 'Oleg',
  'Oleg: требует внимания': 'Oleg: needs attention',
  'Источник Oleg требует проверки.': 'The Oleg source needs review.',
  'Критических сигналов Oleg нет.': 'No critical Oleg signals.',
  'Аренда': 'Rent',
  'Коммунальные услуги': 'Utilities',
  'Уборка': 'Cleaning',
  'Нужна проверка': 'Needs review',
  'Открыть карточку объекта': 'Open the property card',
  'В задачу': 'Create task',
  'Создаю…': 'Creating…',
  'Задача создана': 'Task created',
  'Задача уже есть': 'Task already exists',
  'Не удалось создать задачу': 'Could not create task',
  'Табло и виджеты': 'Board and widgets',
  'Завести учётку, сбросить пароль, отключить доступ':
    'Create accounts, reset passwords, disable access',

  // ── Вход, онбординг ──
  'Вход': 'Sign in',
  'Войти': 'Sign in',
  'Войти заново': 'Sign in again',
  'Войти через Google': 'Sign in with Google',
  'Логин': 'Login',
  'Логин (email)': 'Login (email)',
  'Пароль': 'Password',
  'Новый пароль': 'New password',
  'Смена пароля': 'Change password',
  'Сменить пароль': 'Change password',
  'Пароль изменён': 'Password changed',
  'Пароли не совпадают': 'Passwords do not match',
  'Не короче 10 символов': 'At least 10 characters',
  'От 10 символов': 'At least 10 characters',
  'Не удалось войти': 'Could not sign in',
  'Не удалось сменить пароль': 'Could not change the password',
  'Первый запуск': 'First run',
  'Создайте первую учётку — она станет администратором: сможет приглашать домочадцев и сбрасывать пароли.':
    'Create the first account — it becomes the administrator: it can invite family members and reset passwords.',
  'Создать и войти': 'Create and sign in',
  'Приглашение': 'Invitation',
  'Вас пригласили в семейный хаб. Заполните свою учётку:':
    'You have been invited to the family hub. Set up your account:',
  'Присоединиться': 'Join',
  'Ссылка не действует: истекла или уже использована. Попросите новую у того, кто ведёт хаб.':
    'This link is no longer valid: it has expired or was already used. Ask the person who runs the hub for a new one.',
  'Выданный пароль': 'Issued password',
  'Выданный пароль виден в логе сервера. Задайте свой, прежде чем продолжить.':
    'The issued password was shown once. Set your own before continuing.',
  'Пароль обновлён. Все устройства разлогинены — войдите заново с новым паролем.':
    'Password updated. All devices were signed out — sign in again with the new password.',
  'Этот Google-аккаунт не привязан ни к одной учётке. Войдите по паролю и привяжите его в настройках.':
    'This Google account is not linked to any hub account. Sign in with a password and link it in Settings.',
  'Не получилось войти через Google. Попробуйте ещё раз или войдите по паролю.':
    'Could not sign in with Google. Try again or sign in with a password.',

  // ── Вход в учётку (настройки) ──
  'Вход в учётку': 'Signing in',
  'Вход по паролю': 'Password sign-in',
  'Привязан': 'Linked',
  'Не привязан': 'Not linked',
  'Не настроен на сервере': 'Not configured on the server',
  'Привязать': 'Link',
  'Отвязать': 'Unlink',
  'Включить': 'Enable',
  'Отключить': 'Disable',
  'Выключить': 'Turn off',
  'отключён': 'disabled',
  'У администратора не отключается: это аварийный вход':
    'Cannot be disabled for the administrator: it is the emergency entrance',
  'Отключён — вход только через Google': 'Disabled — sign-in via Google only',
  'Включён. Можно отключить: Google надёжнее':
    'Enabled. You may disable it: Google is more secure',
  'Включён. Отключить можно после привязки Google':
    'Enabled. Can be disabled once Google is linked',
  'Отключить вход по паролю?': 'Disable password sign-in?',
  'Войти можно будет только через Google. Если гугл-аккаунт станет недоступен, вход вернёт администратор сбросом пароля.':
    'You will only be able to sign in with Google. If the Google account becomes unavailable, the administrator can restore access by resetting your password.',
  'Сначала включите вход по паролю': 'Enable password sign-in first',
  'Google привязан. Теперь можно входить кнопкой на экране входа.':
    'Google linked. You can now use the button on the sign-in screen.',
  'Этот Google-аккаунт уже привязан к другой учётке.':
    'This Google account is already linked to another account.',
  'Не получилось привязать Google. Попробуйте ещё раз.':
    'Could not link Google. Please try again.',

  // ── Пользователи ──
  'Пользователь': 'Member',
  'Пользователей нет.': 'No members yet.',
  'Администратор': 'Administrator',
  'Житель дома': 'Family member',
  'Ребёнок': 'Kid',
  'Пригласить по ссылке': 'Invite with a link',
  'Создать ссылку': 'Create link',
  'Создать вручную (с одноразовым паролем)': 'Create manually (with a one-time password)',
  'Одноразовая, действует неделю. Отправьте её домочадцу — остальное он заполнит сам.':
    'Single-use, valid for a week. Send it to a family member — they fill in the rest themselves.',
  'Ссылка от {from} · действует до {to}': 'Link from {from} · valid until {to}',
  'Ссылка от {from} · Истекло {to}. Доступ по ней закрыт.': 'Link from {from} · Expired {to}. It no longer grants access.',
  'Ссылка от {from} · использована': 'Link from {from} · used',
  'Ссылка от {from} · использована · {name}': 'Link from {from} · used · {name}',
  'Ссылка от {from} · отозвана': 'Link from {from} · revoked',
  'Заг. {level}': 'H{level}',
  'Сбросить пароль': 'Reset password',
  'Пароль создан. Он показывается один раз.': 'Password created. It is shown only once.',
  'Передайте его владельцу учётки. При первом входе система попросит задать свой пароль.':
    'Hand it to the account owner. On first sign-in they will be asked to set their own password.',
  '{name} будет разлогинен на всех устройствах и получит новый пароль.':
    '{name} will be signed out on all devices and given a new password.',
  'Не удалось создать пользователя': 'Could not create the member',
  'Не удалось изменить доступ': 'Could not change access',
  'Администратор управляет учётками и настройками, но не видит чужие приватные заметки — выборки фильтруются по владельцу без исключений для роли.':
    'The administrator manages accounts and settings but cannot see anyone’s private notes — queries filter by owner with no exception for the role.',
  'имя@hub.local': 'name@hub.local',

  // ── Задачи ──
  'Задача': 'Task',
  'Новая задача': 'New task',
  'Новая задача в этом проекте': 'New task in this project',
  'Подзадача': 'Subtask',
  'Вложенная задача': 'Nested task',
  'Название вложенной задачи': 'Nested task name',
  'Добавить задачу': 'Add task',
  'Добавить подзадачу': 'Add subtask',
  'Стори': 'Story',
  'Доска': 'Board',
  'Список': 'List',
  'Статус': 'Status',
  'Приоритет': 'Priority',
  'Любой приоритет': 'Any priority',
  'Низкий': 'Low',
  'Обычный': 'Normal',
  'Высокий': 'High',
  'Срочно': 'Urgent',
  'Когда-нибудь': 'Someday',
  'К работе': 'To do',
  'В работе': 'In progress',
  'Готово': 'Done',
  'Отменено': 'Cancelled',
  'Срок': 'Due date',
  'Исполнитель': 'Assignee',
  'Все исполнители': 'All assignees',
  'Без исполнителя': 'Unassigned',
  'Не назначен': 'Unassigned',
  'Просрочено': 'Overdue',
  'Показывать выполненные': 'Show completed',
  'Отметить выполненной': 'Mark as done',
  'Вернуть в работу': 'Reopen',
  'Проект': 'Project',
  'Новый проект': 'New project',
  'Все проекты': 'All projects',
  'Без проекта': 'No project',
  'Проект не найден': 'Project not found',
  'Удалить задачу': 'Delete task',
  'Задача не найдена': 'Task not found',
  'Повтор': 'Repeat',
  'Повторение': 'Recurrence',
  'Повторяется': 'Repeats',
  'Не повторяется': 'Does not repeat',
  'Повтор назначен на {date}': 'Next occurrence scheduled for {date}',
  'Повтор считается от срока — задайте дату': 'Recurrence counts from the due date — set one',
  'Задача закрыта. Следующий повтор назначен на {date}.':
    'Task closed. The next occurrence is scheduled for {date}.',
  'Вместе с ней удалятся вложенные задачи: {n}.': 'Its nested tasks will be deleted with it: {n}.',
  'Задач нет. Добавьте первую — строка ввода под списком.':
    'No tasks. Add the first one — the input line is below the list.',
  'Перетащите задачу сюда': 'Drop a task here',
  'В архиве пока ничего нет. Проект попадает сюда из своих настроек.':
    'The archive is empty. A project gets here from its own settings.',
  'В проекте {n} {unit}. Удаление проекта удалит и задачи — сначала уберите проект в архив или перенесите их.':
    'The project has {n} {unit}. Deleting the project deletes its tasks too — archive the project or move them first.',
  'Настроить проект {title}': 'Configure project {title}',
  'Глубже трёх уровней задачи не вкладываются: стори, таск, сабтаск':
    'Tasks nest at most three levels deep: story, task, subtask',
  'Не помещается: глубже трёх уровней задачи не вкладываются':
    'Does not fit: tasks nest at most three levels deep',
  'Задачу нельзя вложить в саму себя': 'A task cannot be nested inside itself',
  'Родительская задача не найдена': 'Parent task not found',
  'Родительская задача из другого проекта': 'Parent task belongs to another project',
  'Ожидается список задач': 'A list of tasks is expected',
  'Не удалось загрузить задачи': 'Could not load tasks',
  'Задачи со сроком': 'Tasks with a due date',
  'Задача: {project}': 'Task: {project}',

  // ── Календарь ──
  'Событие': 'Event',
  'Новое событие': 'New event',
  'Название события': 'Event name',
  'Укажите название события': 'Enter an event name',
  'События дня': 'Events of the day',
  'Новый календарь': 'New calendar',
  'Календарь не найден': 'Calendar not found',
  'Событие не найдено': 'Event not found',
  'Неделя': 'Week',
  'Месяц': 'Month',
  'День': 'Day',
  'Лента': 'Agenda',
  'Этот месяц': 'This month',
  'Предыдущий месяц': 'Previous month',
  'Следующий месяц': 'Next month',
  'Начало': 'Start',
  'Конец': 'End',
  'Время начала': 'Start time',
  'Время конца': 'End time',
  'Весь день': 'All day',
  'весь день': 'all day',
  'Где': 'Where',
  'Кто идёт': 'Who is going',
  'Предупредить': 'Remind',
  'Не предупреждать': 'No reminder',
  'За день': 'A day before',
  'За три дня': 'Three days before',
  'За неделю': 'A week before',
  'За две недели': 'Two weeks before',
  'За месяц': 'A month before',
  'Каждый день': 'Every day',
  'Каждую неделю': 'Every week',
  'Раз в две недели': 'Every two weeks',
  'Каждый месяц': 'Every month',
  'Раз в квартал': 'Every quarter',
  'Каждый год': 'Every year',
  'Удалить событие': 'Delete event',
  'Удалить серию': 'Delete series',
  'Отменить этот раз': 'Skip this occurrence',
  '«{title}» будет удалено.': '“{title}” will be deleted.',
  '«{title}» исчезнет из всех дат, включая прошедшие.':
    '“{title}” will disappear from all dates, including past ones.',
  'Событие не повторяется — удалите его целиком': 'The event does not repeat — delete it entirely',
  'Нужна дата экземпляра': 'Occurrence date is required',
  'У события со временем нужны часы и минуты': 'A timed event needs hours and minutes',
  'Его события видите только вы — даже администратор не увидит':
    'Only you can see its events — not even the administrator',
  'Этот календарь принадлежит другому человеку': 'This calendar belongs to someone else',
  'В календаре {n} {unit}. Удаление календаря удалит и события.':
    'The calendar has {n} {unit}. Deleting the calendar deletes its events too.',
  'Настроить календарь {name}': 'Configure calendar {name}',
  'Скрыть календарь {name}': 'Hide calendar {name}',
  'Показать календарь {name}': 'Show calendar {name}',
  'Добавить событие на {date}': 'Add an event on {date}',
  'Нажмите на любой день в сетке, чтобы добавить событие.':
    'Click any day in the grid to add an event.',
  'В этом промежутке ничего не запланировано.': 'Nothing is planned for this period.',
  'На сегодня событий нет.': 'No events today.',
  'Не удалось загрузить календарь': 'Could not load the calendar',
  'Правило повтора не разобрать': 'Could not parse the recurrence rule',
  'Ближайшая неделя': 'Next 7 days',
  'Ближайшее': 'Coming up',
  'Дедлайнов на неделю вперёд нет.': 'No deadlines in the next 7 days.',

  // ── Заметки ──
  'Заметка': 'Note',
  'Новая': 'New',
  'Без названия': 'Untitled',
  'Заметок нет. Начните с кнопки «Новая».': 'No notes. Start with the “New” button.',
  'Заметок пока нет.': 'No notes yet.',
  'Заметки пока нет': 'No note yet',
  'Выберите заметку слева или создайте новую.': 'Pick a note on the left or create a new one.',
  'Папка': 'Folder',
  'Новая папка': 'New folder',
  'Без папки': 'No folder',
  'Папка не найдена': 'Folder not found',
  'Укажите название папки': 'Enter a folder name',
  'Настроить папку {name}': 'Configure folder {name}',
  'Приватная': 'Private',
  'Общая': 'Shared',
  'Обычная': 'Regular',
  'Личный': 'Personal',
  'личный': 'personal',
  ' (личный)': ' (personal)',
  ' · личный': ' · personal',
  'Приватную заметку видит только её владелец': 'A private note is visible only to its owner',
  'Приватной заметку делает её владелец': 'Only the owner can make a note private',
  'Заметка принадлежит другому человеку': 'The note belongs to someone else',
  'Заметка не найдена': 'Note not found',
  'Заметка на эту дату уже есть, и она приватная':
    'A note for this date already exists, and it is private',
  'На эту дату заметки ещё нет': 'There is no note for this date yet',
  'История': 'History',
  'История пуста — заметку ещё не правили после создания.':
    'History is empty — the note has not been edited since creation.',
  'Вернуть версию': 'Restore version',
  'Версия не найдена': 'Version not found',
  'Текущее состояние останется в истории, откат можно будет отменить.':
    'The current state stays in history; the rollback can be undone.',
  'Шаблон': 'Template',
  'Шаблоны': 'Templates',
  'Новый шаблон': 'New template',
  'Из шаблона': 'From template',
  'Шаблон не найден': 'Template not found',
  'Шаблон не попадает в общий список и предлагается при создании заметки':
    'Templates stay out of the main list and are offered when creating a note',
  'Подстановки раскроются при создании заметки:': 'Placeholders expand when a note is created:',
  'дата в виде 2026-08-02.': 'date like 2026-08-02.',
  'Работают и в заголовке.': 'They work in the title too.',
  '«{title}» и её вложения будут удалены безвозвратно.':
    '“{title}” and its attachments will be deleted permanently.',
  '«{title}» ещё не создана. Создать сейчас?': '“{title}” does not exist yet. Create it now?',
  'Удалить заметку': 'Delete note',
  'Не удалось открыть заметку': 'Could not open the note',
  'Ссылается на': 'Links to',
  'Упоминают эту': 'Mentioned by',
  'Ссылка на заметку': 'Link to a note',
  'Ссылка на другую заметку — двойные квадратные скобки. Переход по ней: Cmd или Ctrl и щелчок.':
    'Link to another note with double square brackets. Follow it with Cmd or Ctrl and a click.',
  'Начните писать. [[Ссылка]] связывает заметки': 'Start writing. [[Link]] connects notes',
  'Поиск по заметкам': 'Search notes',
  'Полужирный': 'Bold',
  'Курсив': 'Italic',
  'Выделение': 'Highlight',
  'Ж': 'B',
  'К': 'I',
  'В': 'H',
  'Заголовок {level}': 'Heading {level}',
  'Нумерованный список': 'Numbered list',
  'Чеклист': 'Checklist',
  'Цитата': 'Quote',
  'Таблица': 'Table',
  'Прикрепить файл': 'Attach a file',
  'Приложить': 'Attach',
  'Файл': 'File',
  'файл': 'file',
  'Файлы можно перетащить в текст или вставить из буфера':
    'Drag files into the text or paste from the clipboard',
  'Отпустите — файл прикрепится к заметке': 'Release — the file will attach to the note',
  'Удалить файл': 'Delete file',
  'Файл не найден': 'File not found',
  'Файл не пришёл': 'No file received',
  'Файл потерян на диске': 'File is missing on disk',
  'Не удалось загрузить файл': 'Could not upload the file',
  'Не удалось загрузить': 'Could not load',
  'Вложения': 'Attachments',
  'Ориентир — {n} ГБ. Жёсткого запрета нет, но за ростом стоит следить: вложения не попадают в бэкап на GitHub.':
    'The guideline is {n} GB. There is no hard limit, but keep an eye on growth: attachments are not part of the GitHub backup.',
  '{{дата}}': '{{дата}}',
  '{{время}}': '{{время}}',
  '{{автор}}': '{{автор}}',
  '{{изо}}': '{{изо}}',

  // ── Деньги ──
  'Операции': 'Operations',
  'Дашборд': 'Dashboard',
  'Денежные операции': 'Transactions',
  'Операции · внимание': 'Operations · attention',
  'Операция': 'Transaction',
  'Новая операция': 'New transaction',
  'Операция не найдена': 'Transaction not found',
  'Трата': 'Expense',
  'трата': 'expense',
  'Траты': 'Spending',
  'Доход': 'Income',
  'доход': 'income',
  'Доходы': 'Income',
  'Перевод': 'Transfer',
  'Счёт': 'Account',
  'Новый счёт': 'New account',
  'Добавить счёт': 'Add account',
  'Счёт не найден': 'Account not found',
  'Счёт получателя не найден': 'Destination account not found',
  'Выберите счёт': 'Choose an account',
  'Выберите счёт получателя': 'Choose a destination account',
  'Со счёта': 'From account',
  'На счёт': 'To account',
  'Этот счёт принадлежит другому человеку': 'This account belongs to someone else',
  'Операции и остаток видите только вы': 'Only you can see its transactions and balance',
  'Счетов пока нет. Начните с того, где лежат деньги: карта, наличные, копилка.':
    'No accounts yet. Start with wherever the money is: a card, cash, a piggy bank.',
  'Настроить счёт {name}': 'Configure account {name}',
  'По счёту {n} {unit}. Удаление сотрёт и их — лучше убрать счёт в архив.':
    'The account has {n} {unit}. Deleting wipes them too — archiving is safer.',
  'Карта': 'Card',
  'Наличные': 'Cash',
  'Копилка': 'Piggy bank',
  'Валюта': 'Currency',
  'Валюту потом не сменить, если по счёту уже есть операции':
    'The currency cannot be changed once the account has transactions',
  'У счёта есть операции — валюту менять нельзя, создайте новый счёт':
    'The account has transactions — the currency cannot change, create a new account',
  'Валюты не складываются: курса в системе нет, поэтому общего итога тоже.':
    'Currencies are not added together: there is no exchange rate in the system, so no grand total either.',
  'Валюты разные, а курса в системе нет — введите, сколько пришло по факту':
    'The currencies differ and there is no exchange rate — enter the amount actually received',
  'Сумма': 'Amount',
  'Не разобрал сумму': 'Could not parse the amount',
  'Укажите сумму больше нуля': 'Enter an amount above zero',
  'Укажите полученную сумму': 'Enter the amount received',
  'Категория': 'Category',
  'Категории': 'Categories',
  'Без категории': 'No category',
  'Категория трат': 'Expense category',
  'Категория доходов': 'Income category',
  'Категория не найдена': 'Category not found',
  'Категория не того вида: у трат и доходов они разные':
    'Wrong category kind: expenses and income use different ones',
  'Категорий этого вида пока нет — их можно завести на странице денег.':
    'No categories of this kind yet — create them on the Money page.',
  'Сначала заведите категорию трат': 'Create an expense category first',
  'У перевода категории нет': 'Transfers have no category',
  'У перевода нужны счёт получателя и сумма зачисления':
    'A transfer needs a destination account and the amount received',
  'Место': 'Place',
  'Записать трату': 'Record an expense',
  'Записал, скрыть': 'Recorded, hide',
  'Дата — сегодня. Перевод, доход или другую дату задайте кнопкой «Операция».':
    'The date is today. For a transfer, income or another date use the “Transaction” button.',
  'Зачислить': 'Credit',
  'Списать': 'Debit',
  'Провести': 'Post',
  'Не было': 'Did not happen',
  'Сверить': 'Reconcile',
  'Сверка: {name}': 'Reconcile: {name}',
  'Не сверялся': 'Never reconciled',
  'Сходится с банком': 'Matches the bank',
  'Расхождение': 'Discrepancy',
  'Укажите дату и фактический остаток': 'Enter the date and the actual balance',
  'Фактический остаток по банку, {currency}': 'Actual bank balance, {currency}',
  'Фактическая сумма': 'Actual amount',
  'Итоги месяца': 'Month summary',
  'По категориям': 'By category',
  'Трат за месяц нет.': 'No spending this month.',
  'За этот месяц операций нет.': 'No transactions this month.',
  'Не удалось создать операцию': 'Could not create the transaction',
  'Лимит': 'Budget',
  'Лимиты': 'Budgets',
  'Новый лимит': 'New budget',
  'Лимит на месяц': 'Monthly budget',
  'Лимит не найден': 'Budget not found',
  'Укажите сумму лимита': 'Enter the budget amount',
  'Лимит имеет смысл только для категории трат': 'Budgets only make sense for expense categories',
  'Лимитов нет. Поставьте лимит на категорию — и станет видно, сколько от него осталось.':
    'No budgets. Set one on a category and you will see how much of it is left.',
  'осталось ': 'left ',
  'перерасход ': 'over by ',
  'Только на': 'Only for',
  'только этот месяц': 'this month only',
  'Разовое исключение. В остальных месяцах останется постоянный лимит':
    'A one-off exception. Other months keep the standing budget',
  'Регулярные': 'Recurring',
  'Регулярная операция': 'Recurring transaction',
  'Новая регулярная операция': 'New recurring transaction',
  'Правило не найдено': 'Rule not found',
  'Удалить правило': 'Delete rule',
  'Аренда, подписка, зарплата': 'Rent, subscription, salary',
  'Регулярных операций нет. Сюда просятся аренда, подписки, зарплата — всё, что повторяется.':
    'No recurring transactions. Rent, subscriptions, salary — anything that repeats belongs here.',
  'Создавать самостоятельно': 'Create automatically',
  'создаётся сама': 'created automatically',
  'с подтверждением': 'with confirmation',
  'Годится для аренды, которую списывают в срок. Зарплату лучше подтверждать: она приходит с задержкой, и запись вперёд времени испортит остаток':
    'Good for rent that is charged on time. Salary is better confirmed: it arrives late, and recording it ahead of time would skew the balance',
  'Сумму можно поправить перед проведением: зарплата с премией или счёт за воду редко совпадают с плановыми.':
    'You can adjust the amount before posting: a salary with a bonus or a water bill rarely matches the plan.',
  'Чек': 'Receipt',
  'чек': 'receipt',
  'Убрать чек': 'Remove receipt',
  'Не удалось загрузить чек': 'Could not upload the receipt',
  'Чек можно приложить после сохранения операции.':
    'A receipt can be attached after the transaction is saved.',
  'Снимок уменьшается перед отправкой — читать с чека нужно сумму и дату':
    'The photo is downscaled before upload — it only needs to show the amount and date',
  'Нужен месяц в формате ГГГГ-ММ': 'A month in YYYY-MM format is required',
  'Нужны границы периода': 'Period boundaries are required',
  'Нужны границы диапазона from и to': 'Range boundaries from and to are required',
  'Диапазон больше года запрашивать незачем': 'There is no reason to request more than a year',

  // ── Дашборд ──
  'На сегодня': 'For today',
  'На сегодня ничего не запланировано.': 'Nothing planned for today.',
  'Всё на сегодня закрыто.': 'Everything for today is done.',
  'Последние заметки': 'Recent notes',
  'Переезд': 'The move',
  'Дата переезда': 'Moving date',
  'Дата переезда не задана. Укажите её в настройках, и здесь появится отсчёт.':
    'The moving date is not set. Add it in Settings and a countdown will appear here.',
  'От неё считается отсчёт': 'The countdown counts from it',
  '{unit} назад': '{unit} ago',
  'Накоплено': 'Saved so far',
  'Изменить накопленную сумму': 'Edit the saved amount',
  'Сумма в евро': 'Amount in euros',
  'Введите сумму в евро, например 4500': 'Enter an amount in euros, e.g. 4500',
  'Цель, €': 'Goal, €',
  'Ноль — не показывать прогресс': 'Zero — hide the progress bar',
  'Подпись к накоплениям': 'Savings caption',
  'Заголовок на табло': 'Board title',
  'Не удалось сохранить. Проверьте, что сервер запущен':
    'Could not save. Check that the server is running',

  // ── Быстрое добавление / поиск ──
  'Искать по задачам, заметкам, событиям и файлам': 'Search tasks, notes, events and files',
  'Ничего не нашлось': 'Nothing found',
  'Нужно минимум три символа': 'At least three characters are needed',
  'Для поиска нужно минимум 3 символа': 'Search needs at least 3 characters',
  'Cmd + Shift + F · стрелки и Enter': 'Cmd + Shift + F · arrows and Enter',

  // ── Серверные ошибки ──
  'Нужно войти': 'Sign in required',
  'Сначала смените пароль': 'Change your password first',
  'Неверный логин или пароль': 'Wrong login or password',
  'Введите логин и пароль': 'Enter login and password',
  'Слишком много попыток. Попробуйте через 15 минут': 'Too many attempts. Try again in 15 minutes',
  'Текущий пароль указан неверно': 'The current password is incorrect',
  'Проверьте поля': 'Check the fields',
  'Некорректный запрос': 'Invalid request',
  'Некорректные параметры запроса': 'Invalid request parameters',
  'Некорректный путь': 'Invalid path',
  'Такого метода нет': 'No such method',
  'Нечего менять': 'Nothing to change',
  'Сервер недоступен': 'Server unavailable',
  'Только администратор': 'Administrators only',
  'Раздел доступен только администратору': 'This section is for the administrator only',
  'Нельзя отключить самого себя': 'You cannot disable yourself',
  'Пользователь не найден': 'Member not found',
  'Пользователь с таким адресом уже есть': 'A member with this address already exists',
  'Хаб уже настроен': 'The hub is already set up',
  'Ссылка не действует: истекла или уже использована':
    'This link is no longer valid: it has expired or was already used',
  'Вход через Google не настроен': 'Google sign-in is not configured',
  'Администратору пароль отключить нельзя: это аварийный вход':
    'The administrator cannot disable the password: it is the emergency entrance',
  'Сначала привяжите Google — иначе входить будет нечем':
    'Link Google first — otherwise there is no way left to sign in',
  'Сначала включите вход по паролю — иначе входить будет нечем':
    'Enable password sign-in first — otherwise there is no way left to sign in',
  // Подкатегории
  'Входит в': 'Belongs to',
  'Никуда — категория верхнего уровня': 'Nowhere — a top-level category',
  'Подкатегории сворачиваются в родителя в сводке, лимит родителя считает их траты':
    'Subcategories roll up into the parent in the summary; the parent limit counts their spending',
  'Лимит на родительскую категорию учитывает и траты её подкатегорий':
    'A limit on a parent category also counts its subcategories',
  'Само по себе': 'The category itself',
  'Родительская категория не найдена': 'Parent category not found',
  'Родитель должен быть категорией того же вида': 'Parent must be a category of the same kind',
  'Подкатегория не может быть родителем': 'A subcategory cannot be a parent',
  'Категория не может быть родителем самой себя': 'A category cannot be its own parent',
  'У категории есть подкатегории — сначала отвяжите их':
    'This category has subcategories — detach them first',
  'Входящие нельзя архивировать': 'Inbox cannot be archived',
  'Входящие удалить нельзя': 'Inbox cannot be deleted',
  'Настройки должны быть парами строк': 'Settings must be pairs of strings',
  'Заметка на эту дату уже есть, и она приватная (server)': '',
  'Too Many Requests': 'Too Many Requests',
  'useDialogs вызван вне DialogProvider': 'useDialogs called outside DialogProvider',

  // ── Добор по проверке покрытия ──
  '+ доход': '+ income',
  '+ календарь': '+ calendar',
  '+ категория': '+ category',
  '+ лимит': '+ budget',
  '+ папка': '+ folder',
  '+ проект': '+ project',
  '+ регулярная операция': '+ recurring transaction',
  '+ счёт': '+ account',
  '+ трата': '+ expense',
  'Архив': 'Archive',
  'Убрать в архив': 'Archive',
  'Вернуть из архива': 'Unarchive',
  'Включить светлую тему': 'Switch to light theme',
  'Включить тёмную тему': 'Switch to dark theme',
  'Внешний вид': 'Appearance',
  'Тема оформления': 'Appearance theme',
  'Тема сохраняется для этого устройства.': 'The theme is saved for this device.',
  'Системная': 'System',
  'Следует настройке устройства': 'Follows the device setting',
  'Текущая тёмная': 'Classic dark',
  'Привычный тёмный вид Jack OS': 'The familiar dark Jack OS look',
  'Классическая светлая': 'Classic light',
  'Существующая светлая тема': 'The existing light theme',
  'Тёплая светлая': 'Warm light',
  'Для чтения и документов': 'For reading and documents',
  'Контрастная': 'High contrast',
  'Чёткий текст и границы': 'Clear text and borders',
  'Мягкое стекло в навигации': 'Soft glass in navigation',
  'Выбирать пока не из кого: в доме одна учётная запись. Заведите личные учётки в разделе «Пользователи» — тогда здесь появятся все домочадцы.':
    'Nobody to pick yet: the hub has a single account. Create personal accounts in People — everyone will show up here.',
  'Год рождения': 'Year of birth',
  'Необязательно — покажет возраст': 'Optional — shows the age',
  'Код': 'Code',
  'Не удалось добавить': 'Could not add',
  'Не удалось загрузить лимиты': 'Could not load budgets',
  'Не удалось сохранить': 'Could not save',
  'Первый раз': 'First occurrence',
  'Укажите название': 'Enter a name',
  'Валюта по умолчанию': 'Default currency',
  'Подставляется в новые счета и лимиты. Любой код ISO 4217':
    'Pre-filled for new accounts and budgets. Any ISO 4217 code',
  'Начало недели': 'Week starts on',
  'Понедельник': 'Monday',
  'Воскресенье': 'Sunday',
  'Демо': 'Demo',
  'Общий': 'Shared',
  'Проверьте, что сервер хаба запущен, и обновите страницу.':
    'Check that the hub server is running, then reload the page.',
  'Это демо с примером данных: у вас будет собственная копия, трогайте что угодно. Через пару часов простоя она исчезнет без следа.':
    'This is a demo with sample data: you get your own private copy, so touch anything you like. After a couple idle hours it vanishes without a trace.',
  'Попробовать демо': 'Try the demo',
  'Открываю': 'Opening',
  'Отключено в демо-режиме': 'Disabled in the demo',
  'Язык': 'Language',
  'Настройка этого устройства: телефон и общий стенд могут говорить на разных языках.':
    'A per-device setting: a phone and the shared kiosk can speak different languages.',
  'Лиды': 'Leads',
  'Трансферы': 'Transfers',
  'Команда': 'Team',
  'Лидов нет': 'No leads',
  'Записей нет': 'No records',
  'источник': 'source',
  'оплата': 'payment',
  'объект': 'unit',
  'Гость': 'Guest',
  'Объект': 'Unit',
  'Бронь': 'Booking',
  'Оплата': 'Payment',
  'Цена': 'Price',
  'Маржа': 'Margin',
  'День аренды': 'Rent day',
  'Заезд': 'Check-in',
  'Выезд': 'Check-out',
  'Платёж к сверке': 'Payment to review',
  'Заезды': 'Check-ins',
  'Выезды': 'Check-outs',
  'Платежи к сверке': 'Payments to review',
  'Лиды new': 'New leads',
  'Jack Inbox недоступен': 'Jack Inbox unavailable',
  'OPS_INBOX_SPLIT выключен или маршрут ещё не задеплоен. Это не список задач хаба.': 'OPS_INBOX_SPLIT is off or not deployed yet. This is not the hub task inbox.',
  'Нет решений и исключений во входящих': 'No decisions or exceptions in inbox',
  'Квоты Cursor': 'Cursor quotas',
  'Квоты Cursor в Jack OS не подключены. Лимиты смотри в настройках Grok Bot.': 'Cursor quotas are not wired in Jack OS. Check limits in Grok Bot settings.',
  'статус неизвестен · probe follow-up': 'status unknown · probe follow-up',
  'Скопировать id': 'Copy id',
  'только чтение; запись в Oleg staff': 'read-only; write stays in Oleg staff',
  'Источник лидов недоступен': 'Leads source unavailable',
  'Источник недоступен': 'Source unavailable',
  'Ещё на сегодня': 'More for today',
  'сверка': 'review',

  // ── Навигация ──
  // Подписи сайдбара обязаны переводиться: раньше часть из них была
  // захардкожена по-русски и на английской локали оставалась русской.
  'Объекты и гости': 'Properties & guests',
  'Работа': 'Work',
  'Сервис': 'Service',
  'Выполнения': 'Runs',
  'Пока нет выполнений': 'No runs yet',
  'Неразобранное': 'Unsorted',
  'Работа людей': 'Human work',
  'Быстрые записи, которые ещё не разложены по проектам.': 'Quick captures not yet sorted into projects.',
  'Что нужно сделать, кто отвечает и к какому сроку.': 'What needs to be done, who owns it, and by when.',
  'История исполнения': 'Execution history',
  'Что запускалось, что выполняется и чем закончилось. Это не список задач.': 'What ran, what is running, and how it ended. This is not a task list.',
  'Решения и исключения': 'Decisions & exceptions',
  'Только остановленные операции, где нужен ваш ответ, решение или подтверждение.': 'Only stopped operations that need your reply, decision, or approval.',
  'Объекты': 'Properties',
  'Бронирования': 'Bookings',
  'Заявки': 'Enquiries',
  'Регистрация гостей': 'Guest registration',
  'Мои дела': 'My tasks',
  'Заезды, выезды и свободные дни по квартирам': 'Check-ins, check-outs and free days by apartment',
  'TM-30': 'TM-30',
  'Агенты': 'Agents',
'Люди': 'People',
  'Бизнес': 'Business',
  'Анализ рынка': 'Market intelligence',
  'Диагностика': 'Diagnostics',
  'Профиль и настройки': 'Profile & settings',
  'Требует внимания: {count}': 'Needs attention: {count}',
  // ── Документы ──
  'Документы': 'Documents',
  'Архив текстов. Цены внутри документов — архив, не действующие цены.': 'Archive of texts. Prices inside documents are archival, not current prices.',
  'Документов нет': 'No documents',
  'Документов нет. Правила, инструкции и тексты появятся здесь, когда их добавят.': 'No documents yet. Rules, instructions and texts will show up here once they are added.',
  'Аудит': 'Audit',
  'Архив цен': 'Price archive',
  'Черновик': 'Draft',
  'Пост': 'Post',
  'Правила': 'Rules',
  'Спецификация': 'Specification',
  'Это архивный текст, не действующие цены.': 'This is archival text, not current prices.',
  'Фото': 'Photos',
  'Хранилище пусто': 'Storage is empty',
  'Хранилище не пусто; загрузка отключена.': 'Storage is not empty; uploads are disabled.',
  'Дата не указана': 'Date not provided',
  'Загрузка…': 'Loading\u2026',
  'Некорректные параметры': 'Invalid parameters',
  'Не удалось прочитать документы: ключ источника не задан': 'Could not read documents: source key is not set',
  'Источник документов временно недоступен': 'The documents source is temporarily unavailable',
  // Owner UX pass
  'Сотрудник': 'Team member',
  'Ссылка одноразовая и действует неделю. Отправьте её сотруднику — имя и пароль он заполнит сам.':
    'One-time link, valid for a week. Send it to a team member — they will fill in the name and password.',
  'Кто из команды может входить в Jack OS и что ему доступно': 'Who on the team can sign in to Jack OS and what they can access',
  'почта сотрудника': 'team member email',
  'Администратор управляет учётками и настройками, но чужие личные заметки не видит никто, даже администратор.':
    'The administrator manages accounts and settings, but nobody — not even the administrator — sees other people’s private notes.',
  'В поручении не хватает данных о заявке': 'The request is missing ticket details',
  'Всё разобрано': 'All clear',
  'Входящие сейчас недоступны': 'Inbox is unavailable right now',
  'Жду ответа': 'Waiting for reply',
  'Записей пока нет.': 'No records yet.',
  'Записей пока нет. Новая запись появится здесь после оформления услуги.': 'No records yet. A new one will appear here after the service is booked.',
  'Запрос принят. Обновите страницу через минуту.': 'Request accepted. Refresh the page in a minute.',
  'Здесь только то, где нужен ваш ответ: решения, согласования и файлы на проверку.': 'Only what needs your answer: decisions, approvals and files to review.',
  'Исполнитель отметил «Готово без фото».': 'The assignee marked it “Done without photo”.',
  'Напомнить': 'Remind',
  'Неверная ссылка на поручение': 'Invalid request link',
  'Нет решений и файлов на проверку. Новые появятся здесь сами.': 'No decisions or files to review. New ones will appear here automatically.',
  'Не удалось загрузить поручение': 'Could not load the request',
  'Номер объекта': 'Unit number',
  'нужна сверка': 'needs reconciliation',
  'Обновлено': 'Updated',
  'От кого': 'From',
  'Подставляется в новые счета и лимиты, например THB': 'Used for new invoices and limits, e.g. THB',
  'Подтверждение выполнения': 'Proof of completion',
  'Показать полностью': 'Show all',
  'Пока ничего не прислали.': 'Nothing has been sent yet.',
  'Пора напомнить': 'Time to remind',
  'Поручение': 'Request',
  'Поручений нет': 'No requests',
  'Поручения': 'Requests',
  'По этим фильтрам ничего не найдено.': 'Nothing matches these filters.',
  'По этим фильтрам ничего не найдено. Сбросьте оплату, статус или номер объекта.': 'Nothing matches these filters. Clear payment, status or the unit number.',
  'Правила для гостей, инструкции, аудиты и тексты постов. Цены в документах — архивные.': 'Guest rules, how-tos, audits and post texts. Prices in documents are archived.',
  'Сервис временно не отвечает. Попробуйте обновить страницу через пару минут.': 'The service is not responding. Try refreshing in a couple of minutes.',
  'Список поручений сейчас недоступен. Попробуйте обновить страницу позже.': 'The request list is unavailable right now. Try refreshing later.',
  'Срок прошёл': 'Overdue',
  'Табло переезда и накоплений (необязательно)': 'Move and savings board (optional)',
  'Технический журнал': 'Technical log',
  'Тип документа': 'Document type',
  'Укажите ссылку на заметку с фото': 'Paste a link to the note with the photo',
  'Файл получен': 'File received',
  'Фото получено': 'Photo received',
  'Что вы ждёте от гостей, владельцев и подрядчиков — с датой напоминания.': 'What you are waiting for from guests, owners and contractors — with a reminder date.',
  'Что вы решили и почему — чтобы команда не переспрашивала.': 'What you decided and why — so the team does not have to ask again.',
  'Что команда делает по вашим просьбам и чем это закончилось.': 'What the team is doing on your requests and how it ended.',
};



// Пустые значения не нужны — подчистка на случай ошибок редактирования
for (const key of Object.keys(en)) {
  if (!en[key]) delete en[key];
}

/** Английские пары множественного числа: ключ — русская форма единственного. */
export const enPlurals: Record<string, [string, string]> = {
  'день': ['day', 'days'],
  'лид': ['lead', 'leads'],
  'спальня': ['bedroom', 'bedrooms'],
  'операция': ['transaction', 'transactions'],
  'событие': ['event', 'events'],
  'задача': ['task', 'tasks'],
  'файл': ['file', 'files'],
};
